import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spinner } from '@pnl/ui';
import { useAuthStore } from './auth.store';

export function AuthGuard() {
  const status = useAuthStore((s) => s.status);
  const user = useAuthStore((s) => s.user);
  const bootstrap = useAuthStore((s) => s.bootstrap);
  const location = useLocation();

  useEffect(() => {
    if (status === 'unknown') void bootstrap();
  }, [status, bootstrap]);

  if (status === 'unknown' || status === 'loading') {
    return (
      <div className="bg-ink-50 flex min-h-screen items-center justify-center">
        <Spinner size={28} />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 2FA obrigatório no painel: admin sem TOTP habilitado e forcado ao setup
  // antes de qualquer navegacao. requiresTwoFactor reflete twoFactorEnabled do /me.
  if (user && !user.requiresTwoFactor && location.pathname !== '/2fa-setup') {
    return <Navigate to="/2fa-setup" replace />;
  }

  return <Outlet />;
}
